import veterinaryCat from '@assets/images/veterinary-cat.webp';



const VeterinaryBox = (): JSX.Element => {

	return (
		<div className='veterinary-box'>
			
			<div className='veterinary-photo'>
				<img src={veterinaryCat} alt='veterinary-photo-dog' />
			</div>

			<div className='veterinary-text'>
				
				<p>„GASTRO límce nám usnadňují každodenní kontroly jícnové sondy bez nutnosti neustálé manipulace s&nbsp;vatou a&nbsp;dalšími obvazovými materiály. Kočky jsou díky snadné manipulaci a&nbsp;příjemnému límci spokojenější a&nbsp;tak se tyto límce staly nedílnou součástí "cat&nbsp;friendly" přístupu na&nbsp;naší klinice.“</p>
				
				<p>MVDr. Barbora Jankovcová</p>
			
			</div>
		
		</div>
	);
};

export default VeterinaryBox;